import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Wholesale from "@/pages/Wholesale";
import Contact from "@/pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[200] focus:px-4 focus:py-2 focus:bg-[color:var(--ink)] focus:text-[color:var(--cream)] focus:font-ui focus:text-xs focus:uppercase focus:tracking-widest"
      >
        Skip to content
      </a>
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Nav />
          <div id="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/wholesale" element={<Wholesale />} />
              <Route path="/contact" element={<Contact />} />
              {/* Legacy /shop route → wholesale (shop no longer operating) */}
              <Route path="/shop" element={<Navigate to="/wholesale" replace />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </div>
          <Footer />
        </SmoothScroll>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "var(--ink)",
              color: "var(--cream)",
              border: "1px solid var(--ink)",
              borderRadius: 0,
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "13px",
              letterSpacing: "0.05em",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}
